<h3
  *ngIf="!interactions.tasks.length && !interactions.events.length"
  translate="crm/user-profile/interactions/nothing-to-display"></h3>

<ng-container *ngFor="let task of interactions.tasks">
  <div class="crm-interaction" [ngSwitch]="task.TaskSubtype">
    <strong *ngSwitchCase="'Email'" translate="email"></strong>
    <strong *ngSwitchCase="'Call'" translate="crm/user-profile/interactions/phone-call"></strong>
    <strong *ngSwitchDefault>{{ task.TaskSubtype }}</strong>
    <div>{{ task.CreatedDate | dateTimezone: 'medium' }}</div>
    <div>
      <span translate="crm/user-profile/interactions/subject"></span><span>: {{ task.Subject }}</span>
    </div>
    <div>
      <span translate="crm/user-profile/interactions/description"></span><span>: </span>
      <pre>{{ task.Description }}</pre>
    </div>
    <a href="{{ org.instance_url }}/lightning/r/Task/{{ task.Id }}/view" target="_blank">
      {{ task.Id }}
      <mat-icon>launch</mat-icon>
    </a>
  </div>
</ng-container>

<div class="crm-interaction" *ngFor="let event of interactions.events">
  <strong translate="crm/user-profile/interactions/event"></strong>
  <div>
    <span translate="crm/user-profile/interactions/start"> </span
    ><span>: {{ event.StartDateTime | dateTimezone: 'medium' }}</span>
  </div>
  <div>
    <span translate="crm/user-profile/interactions/end"></span
    ><span>: {{ event.EndDateTime | dateTimezone: 'medium' }}</span>
  </div>
  <div>
    <span translate="crm/user-profile/interactions/subject"></span><span>: {{ event.Subject }}</span>
  </div>
  <div>
    <span translate="crm/user-profile/interactions/location"></span><span>: {{ event.Location }}</span>
  </div>
  <div>
    <span translate="crm/user-profile/interactions/description"></span><span>: </span>
    <pre style="white-space: pre-wrap">{{ event.Description }}</pre>
  </div>
  <a href="{{ org.instance_url }}/lightning/r/Event/{{ event.Id }}/view" target="_blank">
    {{ event.Id }}
    <mat-icon>launch</mat-icon>
  </a>
</div>
